/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pie } from '@ant-design/plots';
import IconEmpty from '../../assets/Images/icons/empty';
import { Spin } from 'antd';

export default function Dashboard6({ dataRisk, isLoading }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [riskInfo, setRiskInfo] = useState([]);

    useEffect(() => {
        if (dataRisk) {
            setRiskInfo(
                [
                    {
                        type: t('Draft'),
                        value: dataRisk.draft,
                        total: dataRisk.totalRiskRegister,
                    },
                    {
                        type: t('Reviewing'),
                        value: dataRisk.waitingForReview,
                        total: dataRisk.totalRiskRegister,
                    },
                    {
                        type: t('Reviewed'),
                        value: dataRisk.reviewed,
                        total: dataRisk.totalRiskRegister,
                    },
                    {
                        type: t('Revise'),
                        value: dataRisk.revise,
                        total: dataRisk.totalRiskRegister,
                    },
                    {
                        type: t('Not Registered'),
                        value: dataRisk.unregistered,
                        total: dataRisk.totalRiskRegister,
                    },
                ].reverse()
            );
        }
    }, [dataRisk, lang]);

    const config = useMemo(() => {
        return {
            data: riskInfo,
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => {
                switch (type) {
                    case t('Revise'):
                        return '#EFA6FF';
                    case t('Reviewed'):
                        return '#826AF9';
                    case t('Reviewing'):
                        return '#9E86FF';
                    case t('Draft'):
                        return '#E9DEFA';
                    case t('Not Registered'):
                        return '#B3CDE4';
                    default:
                        return '#B3CDE4';
                }
            },
            radius: 1,
            width: 280,
            height: 280,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: {
                title: true,
                content: {
                    content: t('DashBoardRM.RiskRegister'),
                    style: {
                        fontSize: 14,
                        color: '#505D6F',
                    },
                },
            },
        };
    }, [riskInfo]);

    return (
        <Spin spinning={isLoading}>
            <div className="font-semibold text-xl">
                {lang === 'en'
                    ? 'Risk Register'
                    : 'รายการทะเบียนความเสี่ยง (Risk Register)'}
            </div>
            {dataRisk?.totalRiskRegister ? (
                <div className="grid grid-cols-5 flex items-center">
                    <div
                        className="col-span-3 mt-4"
                        style={{ minHeight: '280px', maxHeight: '280px' }}
                    >
                        <Pie {...config} />
                    </div>
                    <div className="col-span-2">
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#E9DEFA"
                                    />
                                </svg>
                                <div className="pl-2">{t('Draft')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.draft} (
                                {(
                                    (dataRisk.draft /
                                        dataRisk.totalRiskRegister) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#9E86FF"
                                    />
                                </svg>
                                <div className="pl-2">{t('Reviewing')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.waitingForReview} (
                                {(
                                    (dataRisk.waitingForReview /
                                        dataRisk.totalRiskRegister) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#826AF9"
                                    />
                                </svg>
                                <div className="pl-2">{t('Reviewed')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.reviewed} (
                                {(
                                    (dataRisk.reviewed /
                                        dataRisk.totalRiskRegister) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#EFA6FF"
                                    />
                                </svg>
                                <div className="pl-2">{t('Revise')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.revise} (
                                {(
                                    (dataRisk.revise /
                                        dataRisk.totalRiskRegister) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>
                        <div
                            className="grid grid-cols-3 pt-2 pb-6"
                            style={{ borderBottom: '0.5px solid #E9EBF1' }}
                        >
                            <div className="col-span-2 flex items-center">
                                <svg
                                    width="12"
                                    height="13"
                                    viewBox="0 0 12 13"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="6"
                                        cy="6.5"
                                        r="6"
                                        fill="#B3CDE4"
                                    />
                                </svg>
                                <div className="pl-2">
                                    {t('Not Registered')}
                                </div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.unregistered} (
                                {(
                                    (dataRisk.unregistered /
                                        dataRisk.totalRiskRegister) *
                                    100
                                ).toFixed(2)}{' '}
                                %)
                            </div>
                        </div>

                        <div className="grid grid-cols-3 pt-6">
                            <div className="col-span-2">
                                <div className="font-bold">{t('Total')}</div>
                            </div>
                            <div className="col-span-1 text-gray-500">
                                {dataRisk.totalRiskRegister} (100%)
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
        </Spin>
    );
}
